import React from 'react';

import { getServiceName } from '@repo/utils';
import cn from 'classnames';

import { IConDefaultType } from '..';

export enum CoinIconVariant {
  DEFAULT = 'default',
  NON_SHADE = 'non_shade',
}

interface ICoinIconProps extends IConDefaultType {
  variant?: CoinIconVariant;
}

function CoinIcon({ className, size = 24, rotate, flip, variant = CoinIconVariant.DEFAULT }: ICoinIconProps) {
  const uniqueId = React.useId();
  const serviceName = getServiceName() as 'bubblechat' | 'tingle';

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === CoinIconVariant.DEFAULT && serviceName === 'bubblechat' && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill={`url(#paint0_linear_${uniqueId})`} />
          <mask
            id={`mask0_${uniqueId}`}
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <circle cx="12" cy="12" r="12" fill="white" />
          </mask>
          <g mask={`url(#mask0_${uniqueId})`}>
            <ellipse opacity="0.301438" cx="12" cy="7.5" rx="12" ry="7.5" fill={`url(#paint1_linear_${uniqueId})`} />
          </g>
          <path
            d="M15.8498 10.6001C15.0766 10.6001 14.4498 11.2269 14.4498 12.0001C14.4498 12.7733 15.0766 13.4001 15.8498 13.4001C16.623 13.4001 17.2498 12.7733 17.2498 12.0001C17.2498 11.2269 16.623 10.6001 15.8498 10.6001Z"
            fill={`url(#paint2_linear_${uniqueId})`}
          />
          <path
            d="M8.15 10.6001C7.37681 10.6001 6.75 11.2269 6.75 12.0001C6.75 12.7733 7.37681 13.4001 8.15 13.4001C8.92319 13.4001 9.55 12.7733 9.55 12.0001C9.55 11.2269 8.92319 10.6001 8.15 10.6001Z"
            fill={`url(#paint3_linear_${uniqueId})`}
          />
          <path
            d="M13.7499 12H10.2499L10.2781 12.543C10.3645 13.3747 11.1127 14 12.0108 14C12.9712 14 13.7499 13.288 13.7499 12.4098V12Z"
            fill={`url(#paint4_linear_${uniqueId})`}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.15656 10.9199C8.76773 10.9199 9.2632 11.4154 9.2632 12.0265C9.2632 12.6377 8.76773 13.1331 8.15656 13.1331C7.54539 13.1331 7.04993 12.6377 7.04993 12.0265C7.04993 11.4154 7.54539 10.9199 8.15656 10.9199ZM15.8614 10.9199C16.4726 10.9199 16.9681 11.4154 16.9681 12.0265C16.9681 12.6377 16.4726 13.1331 15.8614 13.1331C15.2503 13.1331 14.7548 12.6377 14.7548 12.0265C14.7548 11.4154 15.2503 10.9199 15.8614 10.9199ZM13.4399 12.3108C13.4399 13.106 12.7951 13.7508 11.9999 13.7508C11.2048 13.7508 10.5599 13.106 10.5599 12.3108H13.4399Z"
            fill="#CC6B12"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 11.9998C21 7.0373 16.9626 3 12 3C7.03737 3 3 7.0373 3 11.9998C3 14.0445 3.67015 15.9725 4.9381 17.5759L5.00282 17.6886L5.05677 17.7955L5.09366 17.894C5.11335 17.9602 5.12345 18.029 5.1254 18.1108L5.1212 18.2592L5.10266 18.4352L5.06862 18.6594L5.01973 18.9325L4.87277 19.6862L4.84225 19.8522L4.83668 19.9213L4.8424 20.0153C4.88792 20.3847 5.19944 20.6672 5.57593 20.6672C5.67306 20.6672 5.77611 20.6416 5.87355 20.6032L6.68257 20.2496L6.95968 20.1341L7.08312 20.0867C7.31746 20.0001 7.47952 19.963 7.62167 19.963C7.72592 19.963 7.82406 19.9834 7.93335 20.0274C9.19892 20.6716 10.5698 21 12 21C16.9626 21 21 16.9625 21 11.9998ZM4 11.9998C4 7.58959 7.58965 4 12 4C16.4103 4 20 7.58959 20 11.9998C20 16.4102 16.4103 20 12 20C10.7281 20 9.51261 19.7092 8.38696 19.1362C8.08228 19.0094 7.85824 18.963 7.62167 18.963C7.3411 18.963 7.072 19.0248 6.73668 19.1486L6.60089 19.2007L6.29789 19.3266L5.93 19.486L6.00125 19.1239L6.05298 18.8356L6.09132 18.5853L6.11721 18.3486L6.125 18.139L6.11847 17.9856C6.10823 17.842 6.08671 17.7251 6.05215 17.6089L5.99332 17.4449L5.94954 17.345L5.89559 17.2381L5.80516 17.0777L5.72248 16.9557L5.5172 16.6849C4.52222 15.3147 4 13.7056 4 11.9998Z"
            fill={`url(#paint5_linear_${uniqueId})`}
          />
          <path
            opacity="0.351577"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12ZM0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12Z"
            fill="#FEFB8B"
          />
          <defs>
            <linearGradient
              id={`paint0_linear_${uniqueId}`}
              x1="0"
              y1="0"
              x2="0"
              y2="24"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FCF041" />
              <stop offset="0.865851" stopColor="#F1A503" />
              <stop offset="1" stopColor="#F1CF03" />
            </linearGradient>
            <linearGradient
              id={`paint1_linear_${uniqueId}`}
              x1="0"
              y1="0"
              x2="0"
              y2="15"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0.301857" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
            <linearGradient
              id={`paint2_linear_${uniqueId}`}
              x1="15.8498"
              y1="10.6001"
              x2="15.8498"
              y2="13.4001"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CD8700" />
              <stop offset="1" stopColor="#FFEF00" />
            </linearGradient>
            <linearGradient
              id={`paint3_linear_${uniqueId}`}
              x1="8.15"
              y1="10.6001"
              x2="8.15"
              y2="13.4001"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CD8700" />
              <stop offset="1" stopColor="#FFEF00" />
            </linearGradient>
            <linearGradient
              id={`paint4_linear_${uniqueId}`}
              x1="14.0622"
              y1="14.2005"
              x2="14.0622"
              y2="11.8436"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFEF00" />
              <stop offset="1" stopColor="#CD8700" />
            </linearGradient>
            <linearGradient
              id={`paint5_linear_${uniqueId}`}
              x1="21.5308"
              y1="20.7346"
              x2="21.5308"
              y2="6"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFEF00" />
              <stop offset="1" stopColor="#CC6B12" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === CoinIconVariant.DEFAULT && serviceName === 'tingle' && (
        <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2.43408" width="20" height="20" rx="10" fill="url(#paint0_linear_54_161759)" />
          <rect x="2" y="2.43408" width="20" height="20" rx="10" stroke="#673F00" strokeWidth="0.6" />
          <circle cx="12" cy="12.4341" r="8" fill="url(#paint1_linear_54_161759)" />
          <path
            d="M9.94219 17.4341C9.69517 17.4341 9.5034 17.3528 9.36689 17.1903C9.23688 17.0278 9.17188 16.8165 9.17188 16.5565V9.31165C9.17188 9.04513 9.23688 8.83387 9.36689 8.67785C9.4969 8.51534 9.68542 8.43408 9.93244 8.43408H12.6627C13.2932 8.43408 13.8458 8.56084 14.3203 8.81436C14.7948 9.06138 15.1654 9.41241 15.4319 9.86745C15.6984 10.316 15.8317 10.8393 15.8317 11.4373C15.8317 12.0354 15.6984 12.5587 15.4319 13.0072C15.1654 13.4558 14.7948 13.8035 14.3203 14.0505C13.8458 14.2976 13.29 14.4211 12.6529 14.4211H10.732V16.5565C10.732 16.823 10.6637 17.0375 10.5272 17.2001C10.3972 17.3561 10.2022 17.4341 9.94219 17.4341ZM10.732 13.2315H12.4384C13.0169 13.2315 13.4687 13.0722 13.7938 12.7537C14.1253 12.4287 14.2911 11.9899 14.2911 11.4373C14.2911 10.8783 14.1253 10.4362 13.7938 10.1112C13.4622 9.78619 13.0104 9.62368 12.4384 9.62368H10.732V13.2315Z"
            fill="#FAEB49"
            stroke="#FAEB49"
          />
          <defs>
            <linearGradient
              id="paint0_linear_54_161759"
              x1="2.4"
              y1="3.23408"
              x2="16"
              y2="18.8341"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FAE14C" />
              <stop offset="1" stopColor="#D88304" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_54_161759"
              x1="17.6"
              y1="20.0341"
              x2="4.8"
              y2="3.63408"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFC445" />
              <stop offset="1" stopColor="#F59B1D" />
            </linearGradient>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default CoinIcon;
